import Pagination from 'antd/lib/pagination'

import 'antd/lib/pagination/style'

export * from 'antd/lib/pagination'

export default Pagination
